<template>
  <el-config-provider :locale="locale">
    <router-view :key="route.fullPath" v-if="isShow"></router-view>
  </el-config-provider>
  <div class="h-footer" v-if="footerMsg">
        <span>
            {{footerMsg}}
        </span>
    </div>
</template>
<script >
import { ElConfigProvider } from 'element-plus';
// element plus 分页变为中文
import zhCn from 'element-plus/lib/locale/lang/zh-cn';
import { useStore } from 'vuex';
import { ref } from 'vue';
import { useRoute } from 'vue-router';
export default {
  components: {
    ElConfigProvider,
  },
  setup () {
    const route = useRoute()
    const store = useStore()
    let isShow = ref(false)
    let locale = zhCn
    let getPermitConfig = () => {
      Promise.all([store.dispatch('getPermiAsync'), store.dispatch('getConfigAsync', sessionStorage.getItem('ptCode'))]).then(() => {
        isShow.value = true
      })
    }
    getPermitConfig()
    const footerMsg = JSON.parse(sessionStorage.getItem('loginMessage'))?.projectInfo?.footerMsg;
    return {
      locale, isShow,route,footerMsg
    }; 
  },
};
</script>
<style lang="less">
* {
  margin: 0;
  padding: 0;
  list-style: none;
  font-family: PingFang SC,Microsoft YaHei,Arial,sans-serif,Helvetica Neue,Helvetica,Hiragino Sans GB !important;
}
html,
body,
#app {
  width: 100%;
  box-sizing: border-box;
  background: #f8fafb;
  
}
.h-footer {
    height: 80px;
    width: 100%;
    background: #1c1f21;
    color: #848B8E;
    font-size: 14px;
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      width: 1184px;
      text-align: center;
    }
}

.ql-editor{
  padding: 0  !important;
}
.ql-editor ol{
  padding-left:0px !important;
}
.ql-editor ul {
  padding-left:0px !important;
}
</style>
